class Accordion {
  constructor(elementClass) {
    this.accordion = document.querySelectorAll(`.${elementClass}-item__title`);
  }

  init() {
    for (const element of this.accordion) {
      element.addEventListener('click', function () {
        this.parentElement.classList.toggle('js-active');
      });
    }
  }
}

const accordion = new Accordion('accordion')
accordion.init()
